export const parseFormulaToTokens = (formula: string) => {
  const tokens: Array<{ type: string; value: string }> = []

  const cleanFormula = formula
    .replace(/\[|\]/g, '')
    .replace(/RR/g, 'R')
    .replace(/QQR|QRR/g, 'QR')
    .replace(/QQ/g, 'Q')
    .replace(/[\u200B-\u200D\uFEFF]/g, '')

  const patterns = {
    function:
      /^(IF|COUNTIFS|AGEDETAIL)\((?:[^()]|\((?:[^()]|\([^()]*\))*\))*\)/i,
    comparison: /^(>=|<=|>|<|=)/,
    field: /^[QR]\d+/i,
    number: /^\d+(\.\d+)?/,
    operator: /^[+\-*/]/,
    parentheses: /^[()]/,
    separator: /^[:;,]/,
  }

  let remaining = cleanFormula?.trim()

  while (remaining?.length > 0) {
    let match

    if ((match = remaining?.match?.(patterns?.function))) {
      tokens.push({ type: 'function', value: match?.[0] })
      remaining = remaining?.slice?.(match?.[0]?.length)?.trim()
      continue
    }

    if ((match = remaining?.match?.(patterns.comparison))) {
      tokens.push({ type: 'comparison', value: match?.[0] })
    } else if ((match = remaining?.match?.(patterns.field))) {
      tokens.push({ type: 'field', value: match?.[0] })
    } else if ((match = remaining?.match?.(patterns.number))) {
      tokens.push({ type: 'number', value: match?.[0] })
    } else if ((match = remaining?.match?.(patterns.operator))) {
      tokens.push({ type: 'operator', value: match?.[0] })
    } else if ((match = remaining?.match?.(patterns.parentheses))) {
      tokens.push({ type: 'parentheses', value: match?.[0] })
    } else if ((match = remaining?.match?.(patterns.separator))) {
      tokens.push({ type: 'separator', value: match?.[0] })
    } else {
      throw new Error(`Unrecognized character: ${remaining?.[0]}`)
    }

    remaining = remaining?.slice?.(match?.[0]?.length)?.trim()
  }

  return tokens
}
